// packages block
import React, { useState } from 'react';
import { Dialog } from '@material-ui/core';
// common block
import '../style.css';
import { PreDialogHeader } from '../preDialogHeader';
import DialogContent from './components/notifyParentDialogContent';
// constants, theme, utils and api block
import { preaddStyles } from '../styles';

export const NotifyParentDialog = ({
  open,
  handleClose,
  handleContinue,
  title,
  showCircularProgressBar,
}) => {
  const classes = preaddStyles();
  const [loading, setLoading] = useState(false);
  return (
    <Dialog
      className={classes.root}
      // onClose={handleClose}
      aria-labelledby="simple-dialog-title"
      open={open}
    >
      <div className={classes.mainContainer}>
        <PreDialogHeader
          title={title}
          crossBtn={false}
          handleClose={handleClose}
          showCircularProgressBar={showCircularProgressBar}
        />

        <div className={classes.dropContainer}>
          <DialogContent
            handleClose={handleClose}
            handleContinue={handleContinue}
            loading={loading}
          />
        </div>
      </div>
    </Dialog>
  );
};
